<template lang="html">
  <div v-if="dataBound">
    <b-container>
      <!-- Post initial import upper edit, with audio -->
      <div>
        <div>
          <!-- Headline & Preview -->
          <div :style="embedContainerStyle" class="embed-container">
            <SoundslidesPlayer
              v-if="dataBound"
              :key="'player_'"
              ref="editPlayer"
              :editing_initial_slide_data="show.data.slideArray"
              :editing_initial_overlay_data="show.data.overlayArray"
              :editing_initial_settings_data="show.data.displaySettings"
              :editing_audio_source_url="audioUrl"
              :editing_audio_duration="show.data.audio.duration"
              :editable_overlays="false"
              :force_preload="true"
              :fillscreen="false"
            />
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { db } from "@/fstore";
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer";
import throttle from "lodash/throttle";
import { Show } from "@/models/showModel";

export default {
  name: "ShowPlayerPreviewOnly",
  components: {
    SoundslidesPlayer
  },
  data() {
    return {
      playerMounted: false,
      windowWidth: 100,
      windowHeight: 100,
      throttledOnResize: null,
      show: {},
      dataBound: false
    };
  },
  computed: {
    mode() {
      return this.$route.params.mode || "timeline";
    },
    audioUrl() {
      var source_id = this.show.data.audio.source_id;
      var filename = this.show.data.audio.filename;
      return `https://cdn3.soundslides.com/audio/${source_id}/${filename}`;
    },
    displaySettings() {
      return this.show.data.displaySettings || {};
    },
    embedContainerStyle() {
      var _style = {};
      var padding = 100 / this.displaySettings.aspectRatio || 66.63;
      _style["padding-bottom"] = padding + "%";
      return _style;
    },

    slideArray() {
      if (!this.dataBound) {
        return [];
      }
      return this.show.data.slideArray;
    }
  },
  watch: {},
  beforeDestroy() {
    // Unbind.
    window.removeEventListener("resize", this.throttledOnResize);
  },
  mounted() {
    var id = this.$route.params.id;
    console.log("Show", id);
    var _v = this;
    var showRef = db.collection("editor_shows").doc(id);

    showRef
      .get()
      .then(function(doc) {
        console.log("Current data: ", doc.data());
        var showModelObject = new Show(doc.data());
        _v.show = showModelObject.show;
        _v.dataBound = true;
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });

    this.throttledOnResize = throttle(this.onResize, 20);
    window.addEventListener("resize", this.throttledOnResize);
    this.onResize();
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
    onPlayerMounted() {
      this.playerMounted = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.embed-container {
  position: relative;
  padding: 0;
  //padding-bottom: 66.63%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.absolute {
  position: absolute;
}
</style>
